import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=324d20ea&scoped=true"
import script from "./accountManagement.vue?vue&type=script&lang=js"
export * from "./accountManagement.vue?vue&type=script&lang=js"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=324d20ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d20ea",
  null
  
)

export default component.exports